import { FormattedShopifyProductVariant } from '@portal/types/shopify/product.formatted.types';
import { RawShopifyProductVariant } from '@portal/types/shopify/product.raw.types';

export const reshapeToFormattedShopifyVariant = (variant: RawShopifyProductVariant) => {
  return {
    ...variant,
    sellingPlanAllocations:
      variant.sellingPlanAllocations.edges?.map((sellingPlan) => sellingPlan.node.sellingPlan) || []
  } as FormattedShopifyProductVariant;
};
